import React from 'react';
import { IOS_APP_URL, ANDROID_APP_URL } from '../../storeLinks';

// Download call to action (replaces the template's testimonial slider;
// keeps the component name and section class so the page wiring is unchanged)
function TestimonialHomeOne({ className }) {
    return (
        <section
            className={`dd-testimonial-area dd-download-cta pt-100 pb-100 ${className || ''}`}
            id="download"
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="dd-download-cta-content text-center">
                            <span>Available now</span>
                            <h3 className="title">Drive.Day is live</h3>
                            <p>
                                Download the app for iPhone or Android and sign up right inside the
                                app. You&apos;ll be in your diary in minutes.
                            </p>
                            <ul className="dd-download-cta-btns">
                                <li>
                                    <a href={IOS_APP_URL}>
                                        <i className="fab fa-apple" /> Download for iOS
                                    </a>
                                </li>
                                <li>
                                    <a className="item-2" href={ANDROID_APP_URL}>
                                        <i className="fab fa-google-play" /> Download for Android
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TestimonialHomeOne;
